import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m22.71 18.309-8.608-14.95c-.942-1.603-3.261-1.603-4.203 0L1.29 18.31a2.314 2.314 0 0 0 0 2.334 2.396 2.396 0 0 0 2.101 1.2h17.216a2.396 2.396 0 0 0 2.1-1.2c.422-.72.422-1.613.002-2.334Zm-1.366 1.546a.837.837 0 0 1-.736.413H3.392a.837.837 0 0 1-.736-.413.747.747 0 0 1 0-.76l8.608-14.949a.861.861 0 0 1 1.476 0l8.608 14.95a.747.747 0 0 1-.004.759Z",
		fill: "#000"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22m22.71%2018.309-8.608-14.95c-.942-1.603-3.261-1.603-4.203%200L1.29%2018.31a2.314%202.314%200%200%200%200%202.334%202.396%202.396%200%200%200%202.101%201.2h17.216a2.396%202.396%200%200%200%202.1-1.2c.422-.72.422-1.613.002-2.334Zm-1.366%201.546a.837.837%200%200%201-.736.413H3.392a.837.837%200%200%201-.736-.413.747.747%200%200%201%200-.76l8.608-14.949a.861.861%200%200%201%201.476%200l8.608%2014.95a.747.747%200%200%201-.004.759Z%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E";
